import Typography from "@mui/material/Typography";
import color from "context/MaterialUITheme/color";
import CTrackerTimelineItem, {
  trackerStatusColor,
} from "components/CTimelineItem";
import useTracker from "components/CTracker/useTrackerContext";

const HomeValueVerification: React.FC = () => {
  const { loan } = useTracker();
  const borrowerSteps = loan?.borrowerSteps;
  const status = borrowerSteps?.homeValuationVerification?.status ?? "pending";
  const message = borrowerSteps?.homeValuationVerification?.message;

  return (
    <CTrackerTimelineItem
      status={status}
      title="Home Valuation"
      tooltip="Your value is determined by an Automated Valuation Model or AVM, through a third party appraisal management company. Oftentimes, a full appraisal is not required."
    >
      <Typography
        variant="h6"
        color={color[trackerStatusColor[status] as keyof typeof color]}
      >
        {status === "analyzing" && (message ?? "Analyzing")}
        {status === "failed" && message}
        {status === "success" && message}
      </Typography>
    </CTrackerTimelineItem>
  );
};

export default HomeValueVerification;
